import request from "./request";

export default request;
